import { SideBar } from "pepsico-ds";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import urls from "../../configmap/config.json";
import { useCanManageUser } from "../../hooks/access/canManageUser";
import "./ChatHistoryAnimation.css";
import { navigationUrls } from "../../utils/fieldConstants";
import ChatQuestionHistory from "../ChatHistory/ChatQuestionHistory/ChatQuestionHistory";
import ChatHistory from "../ChatHistory/ChatHistory";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../redux/sideBar/sideBarSlice";

const AppSidebar = () => {
  const canManageUser = useCanManageUser();
  const [Items, setItems] = useState<any[]>([]);
  const [activeItem, setActiveItem] = useState<any>();
  const navigate = useNavigate();
  const location = useLocation();
  const { sessionId } = useParams<{ sessionId: string }>();
  const [isChatHistoryVisible, setIsChatHistoryVisible] =
    useState<boolean>(false);
  const dispatch = useDispatch();
  const isSidebarCollapsed = useSelector(
    (state: any) => state.sidebar.isCollapsed
  );

  const onChange = (item: any) => {
    if (
      item.label === navigationUrls.consultingIntake ||
      item.label === navigationUrls.userGuidelines
    ) {
      window.open(item.url, "_blank");
      setTimeout(() => {
        if (item.label === navigationUrls.userGuidelines) {
          setActiveItem({
            icon: "home",
            label: "Home",
            url: "/",
          });
        }
      }, 0);
    } else {
      dispatch(toggleSidebar(item.label === navigationUrls.ConsultingSearch));
      if (item.label !== "Consulting Search") {
        setActiveItem(item); // Only set active item if it's not Consulting Search
      }
      navigate(item.url);
    }
  };

  useEffect(() => {
    const _items = [
      {
        icon: "home",
        label: "Home",
        url: "/",
      },
      {
        icon: "library_books",
        label: "Consulting Knowledge Mgmt",
        sublinks: [
          //Hide Consulting Search
          // {
          //   label: "Consulting Search​",
          //   url: "/spend-wise-hub/chat-assistant",
          // },
          {
            label: navigationUrls.consultingIntake,
            url: urls.intakeFormURL,
          },
          {
            label: "Close Out Request",
            url: "/spend-wise-hub/upload-engagement_data",
          },
          {
            label: "Engagement History​",
            url: "/spend-wise-hub/engagement-history",
          },
        ],
        url: "/spend-wise-hub",
      },
    ];
    if (canManageUser) {
      _items.push({
        icon: "people",
        label: "User Management",
        url: "/user-list",
      });
    }
    _items.push({
      icon: "import_contacts",
      label: navigationUrls.userGuidelines,
      url: urls.appGuidlines,
    });

    setItems(_items);
  }, [canManageUser, sessionId]);

  useEffect(() => {
    const active = Items.find(
      (i: any) =>
        (location.pathname && i.url === location.pathname) ||
        i.sublinks?.some(
          (sublink: any) =>
            sublink.url === location.pathname &&
            sublink.label !== "Consulting Search​"
        )
    );
    setActiveItem(active);
  }, [location.pathname, activeItem, Items]);

  const isChatAssistantActive =
    /\/spend-wise-hub\/chat-assistant(\/[A-F0-9-]+)?$/.test(location.pathname);

  useEffect(() => {
    if (isChatAssistantActive) {
      dispatch(toggleSidebar(true));
      setIsChatHistoryVisible(true);
    } else {
      setIsChatHistoryVisible(false);
    }
  }, [location.pathname, dispatch]);

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar Component */}
      <SideBar
        activeItem={activeItem}
        bottomText={urls.appVersion}
        items={Items}
        navLinkAction={onChange}
        showBottomAction
        showCollapsed={isSidebarCollapsed}
        height="100%"
        className="AppSideBar"
        isOverlay={false}
        onToggle={(isCollapsed: boolean) => {
          dispatch(toggleSidebar(isCollapsed));
          if (isChatAssistantActive) {
            setIsChatHistoryVisible(isCollapsed);
          }
        }}
      />

      {isChatHistoryVisible && (
        <div
          style={{ position: "relative", top: 0, height: "100%" }}
          className={`chat-history-container ${
            isChatHistoryVisible ? "fade-in" : "fade-out"
          }`}
        >
          {/* <ChatHistory /> */}
          <ChatHistory />
        </div>
      )}
    </div>
  );
};

export default AppSidebar;
